/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import { setDMHRedirection, windowOpenHandler } from '../../../utility/common';
//import EditHouseImg from '../../../../src/asset/images/edit.svg';
import HouseDetailsImg from '../../../../src/asset/images/house_details_icon.svg';
import FullScreenImg from '../../../../src/asset/images/full-screen.svg';
//import ShowRoofImg from '../../../../src/asset/images/show-roof.svg';
import DesignDrawingImg from '../../../../src/asset/images/design-drawing.svg';
import DetailedCostingImg from '../../../../src/asset/images/money-bag.png';
import MaterialQualityImg from '../../../../src/asset/images/brick.png';
import ShareIconImg from '../../../../src/asset/images/share-icon.svg';
import ShareIconGreen from '../../../../src/asset/images/share_green.png';
import ForwardArrowImg from '../../../../src/asset/images/forward-vector-blue.svg';
import SaveMoreIcon from '../../../../src/asset/images/save-more.png';
import AddAnotherImg from '../../../../src/asset/images/add-another.svg';
import DesigningHouse from '../../../asset/images/designing_house.svg';
//import Offer_tag_img from '../../../asset/images/offer_tag_img.svg';
import betaOffer from '../../../asset/images/beta_offer.svg';
import FeedbackIcon from '../../../asset/images/feedback_icon.svg';
import TapToTouch from '../../../asset/images/TapToInteract.svg';
//import GoogleIcon from '../../../asset/images/google_icon.svg';
import SampleDocument from '../sampleDocument';
import ConfirmationScreen from '../confirmation';
import PaymentPopup from '../paymentPopup';
import SharePopUp from '../sharePopup';
import Header from '../../shared-ui/header';
// import { BASE_URL_V4, API_URL, BLOG_URL, SOCIAL_LINKS, WebApp_VERSION, userAgent, FEED_BACK_FORMS, User_Type } from '../../../api/api-config';     //hide blog url for now
import { BASE_URL_V4, API_URL, SOCIAL_LINKS, WebApp_VERSION, userAgent, FEED_BACK_FORMS, User_Type, FREE_DOCUMENT_FOR_ALL } from '../../../api/api-config';
import Loader from '../../shared-ui/Loader';
import { axiosInstance } from '../../../api/coreApi';
import { withTranslation } from 'react-i18next';
import ErrorPopup from '../errorPopup';
import { setInitialPayment } from '../../redux/actions/initiatePayment';
//import DirectBomButtons from '../directBomButtons';
import { getBreakpoint, getLangCodeSelector } from '../../../selectors/commonSelectors';
import PaymentSuccessPage from '../paymentSuccessPage';
import HouseDetailsPopup from '../houseDetailsPopup';
import BudgetScreen from '../budgetScreens';
import { stubTrue } from 'lodash';

class Details extends Component {

  constructor (props) {
    super(props);
    this.fetchHouseDetails=this.fetchHouseDetails.bind(this);
    this.viewSharePopUp=this.viewSharePopUp.bind(this);
    //this.editHouse=this.editHouse.bind(this);
    this.showFullScreen=this.showFullScreen.bind(this);
    this.showSampleDocument=this.showSampleDocument.bind(this);
    this.closePopUp=this.closePopUp.bind(this);
    this.continue=this.continue.bind(this);
    this.closeSharePopUp=this.closeSharePopUp.bind(this);
    //this.submitForm=this.submitForm.bind(this);
    this.fetchProfileDetails=this.fetchProfileDetails.bind(this);
    this.checkPaymentStatus=this.checkPaymentStatus.bind(this);
    this.viewdesignDoc=this.viewDesignDoc.bind(this);
    this.goToDMH=this.goToDMH.bind(this);
    this.continueDoc=this.continueDoc.bind(this);
    this.goToHomeListing=this.goToHomeListing.bind(this);
    this.initiatePayment=this.initiatePayment.bind(this);
    this.redirectLoginPage = this.redirectLoginPage.bind(this);
    this.paymentProcess = this.paymentProcess.bind(this);
    this.editHousePopUp = this.editHousePopUp.bind(this);
    this.useragreed = this.useragreed.bind(this);
    // this.goToBlog=this.goToBlog.bind(this);
    this.endUserFeedBackForm=this.endUserFeedBackForm.bind(this);
    this.redirectPayment=this.redirectPayment.bind(this);
    this.skipPayment=this.skipPayment.bind(this);
    this.gateWaycheck=this.gateWaycheck.bind(this);
    this.validateInput=this.validateInput.bind(this);
    this.validateEmail=this.validateEmail.bind(this);
    this.validateMobile=this.validateMobile.bind(this);
    this.initiatePaymentcall=this.initiatePaymentcall.bind(this);
    this.costFormat=this.costFormat.bind(this);
    //this.validateRedirection=this.validateRedirection.bind(this);

    const isConfirm = props && props.location && props.location.state && props.location.state.isConf;
    this.state = {
      showDocumentPopUp: false,
      confirmation: isConfirm || false,
      showSharePopUp: false,
      payment: false,
      houseData: null,
      isLoading: false,
      budgetSaved:'',
      paymentStatus: null,
      bomCost: null,
      isDocumentFree: FREE_DOCUMENT_FOR_ALL,
      shareUrl:'',
      errorMessage: '',
      showErrorPopUp: false,
      showSuccess: false,
      openEditPopUp: false,
      agreed:false,
      openHouse: false,
      openHouseTotal: false,
      paymentStarted: false,
      houseID: '',
      paymentURL: '',
      paymentGateway:'',
      totalHouse: null,
      permittedHouse: null,
      email: '',
      mobile: null,
      mobileValidation: true,
      emailValidation: true,
      showDisable: false,
      orderId : '' || localStorage.getItem('orderId')
    };
  }

  //User-profile API call
  fetchProfileDetails () {
    const { history } = this.props;
    const jwtToken = localStorage.getItem('jwtToken');

    if (!jwtToken) {
      history.push('/');
    } else {
      this.setState({
        loading: true,
      });
      const URL = BASE_URL_V4 + API_URL.getUserProfile;
      axiosInstance
        .get(URL)
        .then((resp) => {
          const profileData = resp && resp.data && resp.data.data;
          if (profileData) {
            this.setState({
              email: profileData.email,
              mobile: profileData.mobile_number,
              countryCode: profileData.country_code,
              paymentContact: profileData.payment_contact,
              preferredLanguage: profileData.preferred_language,
              userType: profileData.user_type,
              isDocumentFree: !!profileData.is_document_free || this.state.isDocumentFree
            });
          }
        })
        .catch((err) => {
          this.setState({
            loading: false,
          });
          if(err.response.data.status == 'Token is Expired' || err.response.data.status == 'Token is Invalid' || err.response.data.status == 'Authorization Token not found') {
            localStorage.clear();
            this.props.history.push('/login', { expiredError: true });
          }
        });
    }
  }

  endUserFeedBackForm () {
    windowOpenHandler(FEED_BACK_FORMS.end_user_form);
    this.setState({
      showErrorPopUp:false
    });
  }

  validateInput (e) {
    const { mobile } = this.state;
    if(mobile) {
      this.validateEmail();
    } else {
      this.validateMobile();
    }
  }

  validateEmail () {
    this.setState({
      email: this.state.email,
      emailValidation: true
    });
  }

  validateMobile () {
    this.setState({
      mobile: this.state.mobile,
      mobileValidation: true
    });
  }

  useragreed () {
    this.setState({
      agreed:true
    });
  }

  redirectLoginPage () {
    const { history } = this.props;
    history.push('/login');
  }

  //Redirect to blog based on langauge validation
  // goToBlog () {
  //   const langCode = localStorage.getItem('lang');
  //   if(langCode == 'en') {
  //     windowOpenHandler(`${BLOG_URL}/housing-schemes-in-india/`);
  //   } else {
  //     windowOpenHandler(`${BLOG_URL}/${langCode}/housing-schemes-in-india/`);
  //   }
  // }

  editHousePopUp () {
    this.setState({
      openEditPopUp: true
    });
  }

  costFormat (val) {
    return val.toLocaleString('en-IN');
  }


  componentDidMount () {
    const { location } = this.props;
    const prevPage = location && location.state && location.state.from;
    const currentPage = this.props.location.pathname;
    const orderId = localStorage.getItem('orderId');
    
    if(prevPage === 'homes' || currentPage === 'home-details') {
      localStorage.removeItem('orderId');
      localStorage.removeItem('isPaymentStarted');
      this.setState({
        confirmation: false,
        isLoading: true,
      });
      this.fetchHouseDetails();
      this.fetchProfileDetails();
    } else if(prevPage === 'design-my-house') {
      localStorage.removeItem('orderId');
      localStorage.removeItem('isPaymentStarted');
      this.fetchHouseDetails();
      this.fetchProfileDetails();
    } else if (orderId) {
      this.checkPaymentStatus();
    } else {
      this.fetchHouseDetails();
      this.fetchProfileDetails();
    }

    const houseNumber = new URLSearchParams(window.location.search).get('house-id');
    if(houseNumber) {
      localStorage.setItem('houseId', houseNumber);
    }
    this.setState({
      houseID : houseNumber
    });
  }

  fetchHouseDetails () {
    this.setState({
      isLoading: true
    });
    const houseId = localStorage.getItem('houseId');
    const url = `${API_URL.house}/${houseId}`;

    axiosInstance.get(url).then((resp) => {
      const data = resp && resp.data && resp.data.data;
      const payStatus = (data.payment == true ? 'SUCCESS' : 'FAILURE');
      if (data) {
        this.setState({
          houseData: data,
          isLoading: false,
          paymentStatus: payStatus,
          bomCost: data.iap_house_bom_cost,
          isDocumentFree: !!data.is_document_free || this.state.isDocumentFree,
          budgetSaved:data.house_cost_savings,
          actualHouseCost: data.house_cost,
          userBudget: data.budget_value,
          shareUrl:data.model_url,
          shareToken:data.share_token,
          openHouse:data.open_house,
          model:data.model_url,
          totalHouse:data.total_house_count,
          permittedHouse:data.maximum_house_count
        });
        localStorage.setItem('shareToken', data.share_token);
        const { location } = this.props;
        // reading current url
        const currentPage = location.pathname.includes('home-details');
        // clear localStorage DesignDocPrice if url is changed
        if(currentPage) {
          localStorage.setItem('DesignDocPrice', data.iap_house_bom_cost);
        }
        const prevPage = location && location.state && location.state.from;
        if(!data.payment && prevPage !=='homes'|| prevPage !== 'design-my-house' ) {
          const tempOrderId = localStorage.getItem('orderId');
          const isPaymentStarted = localStorage.getItem('isPaymentStarted');
          if(data.payment && prevPage === 'homes') {
            this.viewdesignDoc();
          } else if(data.payment) {
            this.goToHomeListing();
          }
        }

      }
    }).catch((err) => {
      if(err.response.data.status == 'Token is Expired' || err.response.data.status == 'Token is Invalid' || err.response.data.status == 'Authorization Token not found' || err.response.data.status == 'FAILED') {
        localStorage.clear();
        this.props.history.push('/login', { expiredError: true });
      }
      this.setState({
        isLoading: false
      });
    });
  }

  viewSharePopUp () {
    this.setState({
      showSharePopUp: true
    });
  }

  showFullScreen () {
    const { history } = this.props;
    const { houseData } = this.state;
    history.push('/full-screen', { modelUrl : houseData?.model_url });
  }
  

  showSampleDocument () {
    const { history } = this.props;
    const langCode = localStorage.getItem('lang');
    history && history.push(`/sample-document?preferred_language=${langCode}&user_agent=${userAgent}`);
  }

  closePopUp () {
    this.setState({
      showDocumentPopUp: false
    });
  }

  continue () {
    this.setState({
      confirmation: false
    });
  }

  continueDoc () {
    this.setState({
      paymentStatus: this.state.paymentStatus,
      showSuccess: false
    });
    this.goToHomeListing();
  }

  closeSharePopUp () {
    this.setState({
      showSharePopUp: false
    });
  }

  // submitForm (payParams) {
  //   <html>
  //     <head>
  //       <title>Show Payment Page</title>
  //     </head>
  //     <body>
  //       <center>
  //         <h1>Please do not refresh this page...</h1>
  //       </center>
  //       <div>
  //         <form method='post'
  //           //action={payParams.url}
  //           name='paytm'>
  //           <table border='1'>
  //             <tbody>
  //               <tr>
  //                 <td><input type='hidden'
  //                   name='mid'
  //                   value={payParams.mid} /></td>
  //                 <td><input type='hidden'
  //                   name='orderId'
  //                   value={payParams.order_id} /></td>
  //                 <td><input type='hidden'
  //                   name='txnToken'
  //                   value={payParams.paytm_txn_token} /></td>
  //               </tr>
  //             </tbody>
  //           </table>
  //           {/* <script type="text/javascript">{document && document.paytm && document.paytm.submit()}</script> */}
  //         </form>
  //       </div>
  //     </body>
  //   </html>;
  // }

  initiatePaymentcall (value) {
    const url = BASE_URL_V4 + API_URL.payment;
    const { t } = this.props;
    const houseIdRaw = localStorage.getItem('houseId');
    const object = {
      os_type: 'WEB',
      payment_contact : !value ? this.state.paymentContact : value
    };
    if (houseIdRaw) {
      const hid = parseInt(houseIdRaw, 10);
      if (!Number.isNaN(hid)) {
        object.house_id = hid;
      }
    }

    axiosInstance.post(url, object).then((response) => {
      if (response && response.data && response.data.data) {
        const data = response && response.data && response.data.data;
        const formData = {
          url: data.url,
          mid: data.mid,
          orderId: data.order_id,
          transactionToken: data.paytm_txn_token,
          paymentGateway: data.payment_gateway
        };
        this.setState({
          paymentURL: data.url,
          paymentGateway: data.payment_gateway,
          paymentStarted: false,
          mobileValidation: true,
          // mobile: null
        });
        localStorage.setItem('isPaymentStarted', true);
        localStorage.setItem('orderId', data.order_id);
        this.gateWaycheck();
        this.props.setInitialPayment(formData);
      }
    }).catch((err) => {
      console.log('\n\nError in payment------>>', err && err.response && err.response.data);
      if (err && err.response) {
        const errorCodesSuccess = [5001, 5007];
        const errorCodes = [5003, 5004, 5005, 5006, 5007];
        const errData = err.response && err.response.data;
        if (errData && errData.status && errData.status.toLowerCase() == 'failed' && errorCodesSuccess.includes(errData.error_code)) {
          const { location } = this.props;
          const prevPage = location && location.state && location.state.from;
          if(prevPage === 'homes'|| prevPage === 'design-my-house') {
            this.setState({
              showErrorPopUp: false
            });
          } else {
            this.setState({
              showSuccess: true,
              paymentStarted: false,
            });
          }
          localStorage.removeItem('orderId');
        } else if (errData && errData.status && errData.status.toLowerCase() == 'failed' && errorCodes.includes(errData.error_code)) {
          console.log(errData.error_message.payment_contact[0], 'The error message');
          if (errData.error_message.payment_contact[0] === 'The payment contact must be a valid email address.') {
            this.setState({
              // errorMessage: t('cannot_make_payment'),
              // buttonLabel: t('close_button'),
              //paymentStarted: false,
              //showErrorPopUp: true,
              emailValidation: false
            });
          } else {
            this.setState({
              // errorMessage: t('cannot_make_payment'),
              // buttonLabel: t('close_button'),
              //paymentStarted: false,
              //showErrorPopUp: true,
              mobileValidation: false,
            });
          }
          console.log(errData && errData.status && errData.status.toLowerCase() == 'failed' && errorCodes.includes(errData.error_code), 'vvvvvvv');
          // this.fetchHouseDetails();
          // this.fetchProfileDetails();
        }
      }
    });
  }

  //payment initiate call
  initiatePayment (value) {
    if(this.state.paymentContact == null && value != null) {
      if(!this.state.mobile) {
        if(!value || value.length != 10 ) {
          if(!this.state.mobile) {
            this.setState({
              mobileValidation: false
            });
          }
        } else {
          this.initiatePaymentcall(value);
        }
      } else {
        this.initiatePaymentcall(value);
      }
    } else if(this.state.paymentContact != null) {
      this.initiatePaymentcall(value);
    }
  }

  gateWaycheck () {
    if( this.state.paymentGateway === 'EASEBUZZ') {
      this.redirectPayment();
    } else if (this.state.paymentGateway === 'PAYTM') {
      this.redirectPayment();
    } else {
      this.redirectPayment();
      //this.viewDesignDoc();
    }
  }

  // payment status check API call
  checkPaymentStatus () {
    const url = BASE_URL_V4 + API_URL.paymentStatus;
    const orderId = localStorage.getItem('orderId');
    const object = {
      order_id: orderId,
    };
    axiosInstance.post(url, object).then((response) => {
      if (response && response.data) {
        const paymentStatus = get(response, 'data.data.payment_status', 'PENDING');
        this.setState({
          paymentStatus : paymentStatus,
          isLoading : false,
          showSuccess: paymentStatus,
          showErrorPopUp: paymentStatus !== 'SUCCESS' ? true : false,
        });
        const { location } = this.props;
        const prevPage = location && location.state && location.state.from;
        if(prevPage == 'homes' || prevPage == 'design-my-house') {
          localStorage.removeItem('orderId');
          localStorage.removeItem('isPaymentStarted');
          this.setState({
            confirmation: false,
            showErrorPopUp: false,
          });
        }
        if(paymentStatus === 'SUCCESS') {
          localStorage.removeItem('orderId');
          localStorage.removeItem('isPaymentStarted');
          this.setState({ showDisable: false });
          // this.fetchHouseDetails();
        } else if(paymentStatus === 'PENDING') {
          localStorage.removeItem('isPaymentStarted');
          localStorage.removeItem('orderId');
          this.setState({
            showProcessing: true,
            showDisable: true
          });
        } else if(paymentStatus !== 'SUCCESS') {
          localStorage.removeItem('isPaymentStarted');
          localStorage.removeItem('orderId');
          this.setState({ showDisable: false });
          this.fetchHouseDetails();
          this.fetchProfileDetails();
        }
      }
    }).catch((err) => {
      //this.initiatePayment();
      console.log('\n\nError in payment------>>', err && err.response && err.response.data);
    });
  }

  skipPayment () {
    const url = BASE_URL_V4 + API_URL.payment;
    axiosInstance.put(url).then((response) => {
      if (response && response.data && response.data.data) {
        const data = response && response.data && response.data.data;
        this.setState({
          //showSuccess: true,
          paymentStatus: 'SUCCESS'
        });
        this.viewDesignDoc();
      }
    }).catch((err) => {
      console.log('\n\nError in payment------>>', err && err.response && err.response.data);
      if (err && err.response) {
        const errData = err.response && err.response.data;
        if (errData && errData.status && errData.status.toLowerCase() == 'failed' && errData.error_code === 5401) {
          const { t }=this.props;
          this.setState({
            errorMessage: t('cannot_make_payment_three'),
            buttonLabel: t('close_button'),
            showErrorPopUp: true,
            openHouseTotal: true
          });
          localStorage.removeItem('orderId');
        }
      }
    });
  }

  paymentProcess () {
    const { t } = this.props;
    if(FREE_DOCUMENT_FOR_ALL || this.state.userType === User_Type || this.state.isDocumentFree) {
      this.initiatePaymentcall();
      //this.gateWaycheck();
    } else {
      this.setState({
        // errorMessage: t('noFurtherEdit'),
        //showErrorPopUp: true,
        paymentStarted: true,
        //buttonLabel: t('view_design_doc')
      });
    }
    
  }

  redirectPayment () {
    const { paymentURL } = this.state;
    // if(!this.state.openHouseTotal) {
    //   this.skipPayment();
    // } else {
    //   this.setState({
    //     showErrorPopUp: false,
    //     openHouseTotal: false });
    // }
    window && window.open(paymentURL);
    if (paymentURL && String(paymentURL).indexOf('design-document') !== -1) {
      this.goToHomeListing();
    }
  }

  viewDesignDoc () {
    //localStorage.setItem('isValid', true);
    //this.goToHomeListing();
    const houseId = localStorage.getItem('houseId');
    const shareToken = localStorage.getItem('shareToken');
    const langCode = localStorage.getItem('lang');
    const { history } = this.props;
    history && history.push(`/design-document?house_id=${houseId}&share_token=${shareToken}&preferred_language=${langCode}&user_agent=${userAgent}`);
  }


  goToDMH () {
    localStorage.removeItem('orderId');
    const { history, t } = this.props;
    const { openHouse } = this.state;
    if(!openHouse) {
      setDMHRedirection();
      history.push('/design-my-house');
    } else {
      this.setState({
        errorMessage: 'you have one unpaid house',
        buttonLabel: t('close_button'),
        showErrorPopUp: true,
      });
    }
  }

  goToHomeListing () {
    //this.viewDesignDoc();
    this.setState({
      showSuccess : false
    });
    const { history } = this.props;
    history.push('/homes');
  }

  render () {
    const { t, breakpoint, langCode } = this.props;
    const { showDocumentPopUp, paymentContact, mobile, email, showDisable, showSuccess, model, openHouse, paymentStarted, actualHouseCost, confirmation, openEditPopUp, showSharePopUp, payment, isLoading, budgetSaved, bomCost, isDocumentFree, paymentStatus, houseData, agreed, totalHouse, permittedHouse } = this.state;
    const { payParams } = this.props;

    return (
      <div>
        <Loader
          isLoading={isLoading} />
        {!confirmation ?
          <Header /> : null }
        {(confirmation && !showSuccess && budgetSaved > 0) || (confirmation && agreed && !showSuccess) ? <ConfirmationScreen continue={this.continue}
          amount={budgetSaved} /> :
          confirmation && !agreed && <BudgetScreen t={t}
            agreedClick={this.useragreed}
            continue={this.continue}
            editHouse={houseData}
            actualHouseCost={actualHouseCost} />}
        {openEditPopUp && <HouseDetailsPopup
          close={() => this.setState({ openEditPopUp :false })} />}
        {!confirmation ?
          <>
            <div className='top-correction' />
            <div className='details-container banner-container-top'>
              <Loader
                isLoading={isLoading} />
              {breakpoint == 'sm' ?
                <div>
                  <div className='feedback_btn'
                    onClick={this.endUserFeedBackForm}>
                    <img src={FeedbackIcon} />
                    <span className='lbl'>{t('share_feedback')}</span>
                  </div>
                  {paymentStarted && <PaymentPopup
                    close={() => this.setState({ paymentStarted:false,
                      mobileValidation:true,
                      emailValidation:true })}
                    cardDescribtion={(mobile ? 'enter_email_id' : 'enter_phone_num_descrb')}
                    buttonHeader={(mobile ? t('Email_ID') : t('phone_number'))}
                    formOpen={this.initiatePayment}
                    placeholderValue={paymentContact ? paymentContact : ''}
                    value={this.state.value}
                    validations={this.validateInput}
                    // cardError={ this.state.mobile || this.state.mobileValidation ? '' : t('enter_phone_num')}
                    cardError={ this.state.mobileValidation && this.state.emailValidation ? '' : !this.state.mobileValidation ? t('enter_phone_num') : t('enter_valid_inputs')} />}
                  {this.state.showSharePopUp &&
                    <SharePopUp closeSharePopUp={this.closeSharePopUp}
                      text={t('share_design_desc')}
                      shareUrl={this.state.shareUrl}
                      shareText={true} />}
                  {showDocumentPopUp && <SampleDocument closePopUp={this.closePopUp} />}
                  <div className='image-wrapper-3d'
                    style={{ height: '50vh' }}>
                    <iframe src={`${model}&interactive=false`}
                      height='100%'
                      width='100%'
                      loading='lazy' />
                    <div className='tap_to_touch_overlay'
                      onClick={this.showFullScreen}>
                      <img src={TapToTouch} />
                    </div>
                  </div>
                  <div className='option-container'>
                    <div className='option-wrapper'>
                      <div className='image-wrapper'>
                        <img className='image'
                          // src={paymentStatus === 'SUCCESS' ? ShareIconImg : HouseDetailsImg}
                          src={HouseDetailsImg}
                          alt='3d-img' />
                      </div>
                      <div className='text button-pointer'
                        onClick={this.editHousePopUp}>
                        {/* onClick={paymentStatus === 'SUCCESS' ? this.viewSharePopUp : this.editHousePopUp}> */}
                        {/* {paymentStatus === 'SUCCESS' ? t('share_design'):t('houseDetailsTitle')} */}
                        {t('houseDetailsTitle')}
                      </div>
                    </div>
                    <div className='vertical-line' />
                    <div className='option-wrapper'>
                      <div className='image-wrapper'>
                        <img className='image'
                          src={FullScreenImg}
                          alt='3d-img' />
                      </div>
                      <div className='text button-pointer'
                        onClick={this.showFullScreen}>
                        {t('full_screen')}
                      </div>
                    </div>
                    {/* <div className='vertical-line' />
                <div className='option-wrapper'>
                  <div className='image-wrapper'>
                    <img className='image'
                      src={ShowRoofImg}
                      alt='3d-img' />
                  </div>
                  <div className='text'>
                    {t('show_roof')}
                  </div>
                </div> */}
                  </div>
                  {totalHouse < permittedHouse ?
                    <div className='doc_btn_container'>
                      { paymentStatus !== 'SUCCESS' ?
                        <div style={{ position: 'relative',
                          width: '233px',
                          margin: 'auto' }}>
                          {/* <div className='offer_text'>{t('offer_key')}</div>
                        <div className='offer_tag_img'>
                          <img src={Offer_tag_img}
                            alt='offer' />
                        </div> */}
                          { WebApp_VERSION == 'BETA' ?
                            langCode == 'en' ?
                              <><div className='offer_text'>{t('offer_key')}</div><div className='offer_tag_img'>
                                <img src={betaOffer}
                                  alt='offer' />
                              </div></> : <><div className='offer_text'>{t('offer_key')}</div><div className='offer_tag_img_hi_mi'>
                                <img src={betaOffer}
                                  alt='offer' />
                              </div></> : null
                          }
                          {showDisable ? <div className='pending_status'>{t('process_payment')}</div> : null }
                          <div className='get-document'
                            onClick={this.paymentProcess}>
                            { isDocumentFree ?
                              <button className='get-document-submit button-pointer'
                                onClick={this.paymentProcess}>{ t('get_document_for_free')}</button >
                              : WebApp_VERSION == 'BETA' ?
                                langCode == 'en' ?
                                  <button className='get-document-submit button-pointer'
                                    onClick={this.paymentProcess}>{ t('get_document_starting')} <span className='original_price'>₹{this.costFormat(bomCost)}</span></button > :
                                  <button className='get-document-submit button-pointer'
                                    onClick={this.paymentProcess}><span className='original_price'>₹{this.costFormat(bomCost)}</span> { t('get_document_starting')} </button >
                                :
                                langCode == 'en' ?
                                  <button className='get-document-submit button-pointer'
                                    onClick={this.paymentProcess}>{ t('get_document_starting')} <span>₹{this.costFormat(bomCost)}</span></button > :
                                  <button className='get-document-submit button-pointer'
                                    onClick={this.paymentProcess}><span>₹{this.costFormat(bomCost)}</span> { t('get_document_starting')} </button >
                            }
                          </div>
                          <div className='sample-document button-pointer'
                            onClick={this.showSampleDocument}>{t('view_sample_doc')}
                          </div>
                        </div> :
                        <div className='doc_btn_container'>
                          {/* <div className='get-document button-pointer'
                            onClick={this.viewDesignDoc}>
                            {t('view_design_doc')}
                          </div> */}
                          <div className='sample-document button-pointer'
                            onClick={this.viewSharePopUp}>
                            <img className='image share_icon'
                              src={ ShareIconGreen }
                              alt='3d-img' />
                            <div> {t('share_design')} </div>
                          </div>
                        </div>
                    }
                    </div> :
                    <div className='max-house-limit-msg'>
                      {t('maximumHouseLimit')}
                    </div>}
                  {/* add UI status of limiting house for mobile view */}
                  {paymentStatus === 'SUCCESS' || totalHouse > permittedHouse - 1 ? null : <>
                    <div className='include-text'>
                      {t('visava_doc_will_include')}
                    </div>
                    <div className='info-container'>
                      <div className='info-wrapper'>
                        <div className='image-wrapper'>
                          <img className='image'
                            src={DesignDrawingImg}
                            alt='detailed Drawings' />
                        </div>
                        <div className='text'>{t('design_drawing')}</div>
                      </div>
                      <div className='info-wrapper'>
                        <div className='image-wrapper'>
                          <img className='image'
                            src={MaterialQualityImg}
                            alt='Material Quality' />
                        </div>
                        <div className='text'>{t('material_quality')}</div>
                      </div>
                      <div className='info-wrapper'>
                        <div className='image-wrapper'>
                          <img className='image'
                            src={DetailedCostingImg}
                            alt='Detailed Costing' />
                        </div>
                        <div className='text'>{t('detailed_costing')}</div>
                      </div>
                    </div>
                  </> }
                  <div className='share-house-container button-pointer'
                    onClick={paymentStatus === 'SUCCESS' ? this.goToDMH:this.viewSharePopUp}>
                    <div className='share-image-wrapper'>
                      <img className='share-image'
                        src={paymentStatus === 'SUCCESS' ? AddAnotherImg:ShareIconImg}
                        alt='' />
                    </div>
                    <div className='share-text'>{paymentStatus === 'SUCCESS' ? t('design_another_house'):t('share_new_design')}</div>
                    <div className='forward-wrapper'>
                      <img className='forward-image'
                        src={ForwardArrowImg}
                        alt='' />
                    </div>
                  </div>
                  <div className='save-more-wrapper'>
                    <div className='image-container'>
                      <div className='image-wrapper'>
                        <img className='image'
                          src={SaveMoreIcon}
                          alt='' />
                      </div>
                    </div>
                    {/* <div className='text'>{t('save_more_money')}<a className='read-more'
                      onClick={this.goToBlog}> {t('read_more')}</a></div> */}
                    <div className='text'>{t('save_more_money')}</div>
                  </div>
                </div> :
                <div className='detail-wrapper-l'>
                  <div className='feedback_btn'
                    onClick={this.endUserFeedBackForm}>
                    <img src={FeedbackIcon} />
                    <span className='lbl'>{t('share_feedback')}</span>
                  </div>
                  {this.state.showSharePopUp &&
                    <SharePopUp closeSharePopUp={this.closeSharePopUp}
                      text={t('share_design_desc')}
                      shareUrl={this.state.shareUrl}
                      shareText={true} />}
                  {paymentStarted && <PaymentPopup
                    close={() => this.setState({ paymentStarted:false,
                      mobileValidation:true,
                      emailValidation:true })}
                    cardDescribtion={(mobile ? 'enter_email_id' : 'enter_phone_num_descrb')}
                    buttonHeader={(mobile ? t('Email_ID') : t('phone_number'))}
                    formOpen={this.initiatePayment}
                    placeholderValue={paymentContact ? paymentContact : ''}
                    value={this.state.value}
                    validations={this.validateInput}
                    //cardError={ this.state.mobile || this.state.mobileValidation ? '' : t('enter_phone_num')} />}
                    cardError={ this.state.mobileValidation && this.state.emailValidation ? '' : !this.state.mobileValidation ? t('enter_phone_num') : t('enter_valid_inputs')} />}
                  {showDocumentPopUp && (
                    <SampleDocument closePopUp={this.closePopUp} />
                  )}
                  <div className='section-1'>
                    <div className='sub-section-1'>
                      {paymentStatus === 'SUCCESS' ? <div className='house-details-l'>
                        <div className='image-wrapper'>
                          <img className='image'
                            src={HouseDetailsImg}
                            alt='3d-img' />
                        </div>
                        <div className='text button-pointer'
                          onClick={this.editHousePopUp}>
                          {t('houseDetailsTitle')}
                        </div>
                      </div> :
                      <div className='edit-house-l'>
                        <div className='image-wrapper'>
                          <img className='image'
                            src={HouseDetailsImg}
                            alt='3d-img' />
                        </div>
                        <div className='text button-pointer'
                          onClick={this.editHousePopUp}>
                          {t('houseDetailsTitle')}
                        </div>
                      </div>}
                      <div className='full-screen-l'>
                        <div className='image-wrapper'>
                          <img className='image'
                            src={FullScreenImg}
                            alt='3d-img' />
                        </div>
                        <div className='text button-pointer'
                          onClick={this.showFullScreen}>
                          {t('full_screen')}
                        </div>
                      </div>
                      {/* <div className='show-roof-l'>
                        <div className='image-wrapper'>
                          <img className='image'
                          src={ShowRoofImg}
                          alt='3d-img' />
                        </div>
                        <div className='text'>
                          {t('show_roof')}
                        </div>
                        </div> */}
                      <div className='share-design-l'>
                        <div className='share-top-section'>
                          <div className='image-wrapper'>
                            <img className='image'
                              src={ShareIconImg}
                              alt='3d-img' />
                          </div>
                          <div className='text button-pointer'
                            onClick={this.viewSharePopUp}>
                            {t('share_design')}
                          </div>
                        </div>
                        {/* <div className='social_icon_wrapper'>
                          <div className='icon'>
                            <a href={SOCIAL_LINKS.facebook}
                              className='icon'>
                              <img src={FacebookIcon} />
                            </a>
                          </div>
                          <div className='icon'>
                            <a href={SOCIAL_LINKS.twitter}
                              className='icon'>
                              <img src={TwitterIcon} />
                            </a>
                          </div>
                          <div className='icon'>
                            <a href={SOCIAL_LINKS.instagram}
                              className='icon'>
                              <img src={InstagramIcon} />
                            </a>
                          </div>
                          <div className='icon'>
                            <a href={SOCIAL_LINKS.linkedin}
                              className='icon'>
                              <img src={LinkedinIcon} />
                            </a>
                          </div>
                          <div className='icon'>
                            <img src={GoogleIcon} />
                          </div>
                        </div> */}
                      </div>
                      {paymentStatus === 'SUCCESS' || totalHouse > permittedHouse - 1 ? null : <>
                        <div className='include-text'>
                          {t('visava_doc_will_include')}
                        </div>
                        <div className='info-container'>
                          <div className='info-wrapper'>
                            <div className='image-wrapper'>
                              <img className='image'
                                src={DesignDrawingImg}
                                alt='detailed Drawings' />
                            </div>
                            <div className='text'>{t('design_drawing')}</div>
                          </div>
                          <div className='info-wrapper'>
                            <div className='image-wrapper'>
                              <img className='image'
                                src={MaterialQualityImg}
                                alt='Material Quality' />
                            </div>
                            <div className='text'>{t('material_quality')}</div>
                          </div>
                          <div className='info-wrapper'>
                            <div className='image-wrapper'>
                              <img className='image'
                                src={DetailedCostingImg}
                                alt='Detailed Costing' />
                            </div>
                            <div className='text'>{t('detailed_costing')}</div>
                          </div>
                        </div>
                      </> }
                      {/* add the required class for sample doc button in desktop view */}
                      <div className='sample-btn-area'>
                        {paymentStatus !== 'SUCCESS'?
                          <div
                            className='btn'
                            onClick={this.showSampleDocument}>{t('view_sample_doc')}
                          </div> : null }
                      </div>
                      {/* <div>
                        <DirectBomButtons />
                        </div> */}
                    </div>
                    <div className='sub-section-2' />
                    <div className='sub-section-3'>
                      <div className='image-container'>
                        <div className='image-wrapper'>
                          <img className='image'
                            src={SaveMoreIcon}
                            alt='' />
                        </div>
                      </div>
                      <div className='text' >{t('save_more_money')}</div>
                      {/* <a className='read-more'
                        onClick={this.goToBlog}>{t('read_more')}</a> */}
                    </div>
                  </div>
                  <div className='section-2'>
                    <div className='d-modal-container'>
                      <div className='d-image-wrapper'>
                        <iframe src={model}
                          height='100%'
                          width='100%'
                          loading='lazy' />
                      </div>
                    </div>
                    <div className='document-container'>
                      {/* {paymentStatus !== 'SUCCESS'?
                        <div className='sample-documents button-pointer'
                          onClick={this.showSampleDocument}>{t('view_sample_doc')}
                        </div>: null } */}
                      
                      <div>
                        { totalHouse < permittedHouse ?
                        // paymentStatus !== 'SUCCESS'?
                          <div style={{ position: 'relative' }}>
                            { WebApp_VERSION == 'BETA' ?
                              langCode == 'en' ?
                                <><div className='offer_text'>{t('offer_key')}</div><div className='offer_tag_img'>
                                  <img src={betaOffer}
                                    alt='offer' />
                                </div></> : <><div className='offer_text'>{t('offer_key')}</div><div className='offer_tag_img_hi_mi'>
                                  <img src={betaOffer}
                                    alt='offer' />
                                </div></> : null }
                            {showDisable ? <div className='pending_status'>{t('process_payment')}</div> : null }
                            <div className='get-document'
                              onClick={this.paymentProcess}>
                              { isDocumentFree ?
                                <button className='get-document-submit button-pointer'
                                  onClick={this.paymentProcess}>{ t('get_document_for_free')}</button >
                                : WebApp_VERSION == 'BETA' ?
                                  langCode == 'en' ?
                                    <button className='get-document-submit button-pointer'
                                      onClick={this.paymentProcess}>{ t('get_document_starting')} <span className='original_price'>₹{this.costFormat(bomCost)}</span></button > :
                                    <button className='get-document-submit button-pointer'
                                      onClick={this.paymentProcess}><span className='original_price'>₹{this.costFormat(bomCost)}</span> { t('get_document_starting')} </button >
                                  :langCode == 'en' ?
                                    <button className='get-document-submit button-pointer'
                                      onClick={this.paymentProcess}>{ t('get_document_starting')} <span>₹{this.costFormat(bomCost)}</span></button > :
                                    <button className='get-document-submit button-pointer'
                                      onClick={this.paymentProcess}><span >₹{this.costFormat(bomCost)}</span> { t('get_document_starting')} </button >
                              }
                            </div>
                          </div> : null
                          // <div className='max-house-limit-msg'>{t('maximumHouseLimit')}</div>
                          // add UI status of limiting house for Desktop view **********
                          // <div className='doc_btn_container'>
                          //   <div className='get-document'
                          //     style={{
                          //       marginTop: '5px' }} >
                          //     <div className='get-document-submit button-pointer'
                          //       onClick={this.viewDesignDoc}>{t('view_design_doc')} </div>
                          //   </div>
                          // </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }

              {showSuccess === 'SUCCESS' ? <PaymentSuccessPage continueDoc={this.continueDoc} /> : null }
              {/* (paymentStatus !== 'SUCCESS' && this.state.showErrorPopUp) ? <ErrorPopup shown={this.state.showErrorPopUp}
                paymentStatus={this.state.paymentStatus}
                close={() => this.setState({ showErrorPopUp:false })}
                closeOk={() => this.setState({ showErrorPopUp:false })}
                buttonLabel={t('close_button')}
                googleMaps={false}
                showPayment={false}
                message={t('payment_status_failure')} /> */}
            </div>
          </> : <>
          </>
        }
        { this.redirectLoginPage}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setInitialPayment: (data) => {
    dispatch(setInitialPayment(data));
  },
});

const mapStateToProps = (state) => ({
  payParams: (state.homeDetailsState && state.homeDetailsState.payParams) || {},
  breakpoint : getBreakpoint(state),
  langCode: getLangCodeSelector(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(Details)));